// src/modules/purityAnalyzer/components/hud/StatusLed.jsx
// Blinking HUD status indicator: ● SYSTEM ONLINE

import React from 'react';

export default function StatusLed({ color = '#00e5ff', label, speed = 'normal' }) {
  const cls =
    speed === 'fast' ? 'pa-led pa-led-fast' : speed === 'solid' ? 'pa-led pa-led-solid' : 'pa-led';
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 7 }}>
      <span className={cls} style={{ color, background: color }} />
      <span className="pa-label" style={{ color: 'rgba(223,246,255,0.8)' }}>{label}</span>
    </span>
  );
}
